import { useInteriorOrganizerStore } from '../../../data/interior-organizer-store';
import StorageItem from './storage-item';
import { getFilteredItems } from '../../../domain/storage-items-provider';

const StorageItemsList = () => {
    const storageItemsData = useInteriorOrganizerStore(store => store.storageItemsData);
    const filterWidth = useInteriorOrganizerStore(store => store.itemsFilterWidth);
    const filterHeight = useInteriorOrganizerStore(store => store.itemsFilterHeight);
    const filterDepth = useInteriorOrganizerStore(store => store.itemsFilterDepth);
    const filterName = useInteriorOrganizerStore(store => store.itemsFilterName);

    const items = getFilteredItems(
        storageItemsData,
        filterWidth,
        filterHeight,
        filterDepth,
        filterName,
    );

    return (
        <div className="text-sm pb-24">
            {
                items.map((storageItem, i) => {
                    return (
                        <StorageItem
                            key={ storageItem.id }
                            storageItem={ storageItem }
                            index={ i + 1 }
                        />
                    )
                })
            }
        </div>
    )
};

export default StorageItemsList;